import React from 'react';
import { Reveal } from './Reveal';
export function Hook() {
  return <section className="w-full bg-midnight py-24" data-id="element-52">
      <div className="mx-auto max-w-3xl px-6" data-id="element-53">
        <Reveal data-id="element-54">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-rose-glow" data-id="element-55">
            Son las 2 de la mañana
          </p>
        </Reveal>
        <Reveal delay={0.05} data-id="element-56">
          <p className="mt-6 font-display text-2xl leading-relaxed text-cream sm:text-3xl" data-id="element-57">
            Estás mirando el{' '}
            <span className="italic text-electric" data-id="element-58">"en línea"</span>, analizando
            por décima vez ese último mensaje frío o, peor aún, el vacío de una
            conversación que se detuvo sin explicación.
          </p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-59">
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-60">
            Te sientes ridículo/a por llorar a alguien que nunca fue tu pareja
            formal, pero el dolor en tu pecho es tan real como el de un
            divorcio.
          </p>
        </Reveal>
        <Reveal delay={0.15} data-id="element-61">
          <p className="mt-8 font-display text-xl font-semibold text-cream sm:text-2xl" data-id="element-62">
            No estás loco/a. No eres intenso/a. Estás atrapado/a en un limbo
            emocional diseñado para volverte adicto/a a la incertidumbre.
          </p>
        </Reveal>
      </div>
    </section>;
}